import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';
import { Typography, 
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';

//import * as posenet from '@tensorflow-models/posenet';
import '@tensorflow/tfjs-backend-webgl';

import Webcam from './Webcam';
import { readImageListFile,
	     loadAIModel,
		 loadStaticImage } from '../util/aiMain';
import { setupVideoFile,
       } from '../util/videoUtil';
import { INFO,
         TIMES, } from '../util/object';
import { initAnalyzer} from '../util/analysis'
import { initDefender} from '../util/defender'
import { initPerformance} from '../util/performance'
import { initVideoDisplay} from '../util/annotate'


const auth_useStyles = makeStyles(theme => ({
	    dev_root: {
			display: 'flex',
			flexDirection: 'column',
			//maxHeight: '90vh',
			//maxWidth: '90%',
			width: `calc(100% - 250px)`,
			minWidth: '350px',
			marginTop: '0vh',
			marginLeft: '0vh',
			backgroundColor:'#444444',	//4488ff
	    },
	    hidden: {
			display: "none",
		},
		yolo_canvas: {
			minHeight: '450px',
			maxHeight: '550px',
			maxWidth: '100%',
			width: 'auto',
			height: 'auto',
			margin: '5px',
			backgroundColor:'#1c1c27',	//4488ff
		},
	    video_container: {
			display: "none",
			padding: '0',
			margin: '0',
			width: "auto",
			height: "auto",
			flexDirection: "row",
			alignItems: "flex-start",

			marginLeft: '0',
			marginRight: '0',
			marginBottom: '0.7vh',
			width: '100%',
			height: '100%',
			paddingLeft: '0',
			paddingRight: '0',
			position: 'relative',
			//overflow: 'hidden', 
	    },
	    spinner_text: {
			display: 'flex'
	    },
		hardcode: {
			display: "none",
			height: '40px',
			width: '80px',
			backgroundColor:'red',	//4488ff
		}
	}));


const Dev = (props) => {
    const classes = auth_useStyles();

	async function runTest() {
		var path = "assets/images/calib/bo-side-side-3deep.mp4";
		console.log("hardcode.70: START VIDEO LOAD TEST")
		setupVideoFile(path, 1);   // willl do auto read from video
	}

    useEffect(() => {
		console.log("Dev.INIT.60: running useEffect() ", props);
		document.getElementById('file').addEventListener('change', readImageListFile, false);
		document.getElementById('hardcode').addEventListener('click', runTest, false);
		//window.addEventListener('load', setupVideoFile, false);

		document.addEventListener('keydown', function(event) {
			if(event.code == "ArrowLeft") {
				//console.log('Left was pressed');
			} else if(event.code == "ArrowRight") {
				//console.log('Right was pressed');
			}
		});

		var out = loadAIModel();		// load AI model
        Promise.all([ out ]).then((values) => {
            initAnalyzer();
            initDefender();
            initPerformance();
            initVideoDisplay(INFO.analysis_canvas, "dev.112");
            console.log("main.103:   AI init returned  model=", values);
        });

    }, [1]); 



    return (
        <React.Fragment>
	    <div id="dev_root" className={classes.dev_root} >
			<input type="file" id="file" name="file" encType="multipart/form-data" />
			<div id="hardcode" className={classes.hardcode}>HARDCODE</div>

		    <div id="status_text" style={{display: "block"}} />
		    <div id="results" style={{display: "block"}} />
		    <div id="info" style={{display: "none"}} />

			<div id="loading" style={{display: "flex"}}>
		        <div className={classes.spinner_text}>
					Loading PoseNet model...
				</div>
				<div className={classes.sk_spinner}></div>
			</div>

			<Container id="video_container" className={classes.video_container}>
				<div id="vloading" style={{display: "flex"}}></div>
				<video id="video" autoPlay muted={true} position="relative" width="320" height="240" style={{display: "none"}} />
				<canvas id="vcanvas" style={{position: "relative", zIndex: 1, display: "none"}} />

				<canvas id="output" className={classes.yolo_canvas} />
				<canvas id="yolo" className={classes.yolo_canvas} />
				<canvas id="mobile" className={classes.yolo_canvas} />
			</Container>
			<Webcam />
	    </div>

		<img id="preview" alt="no preview available" />
	</React.Fragment>
    )
}

export default Dev;